module.exports = __webpack_public_path__ + "img/t8.889b7ba0.png";